import { applyMiddleware, combineReducers, legacy_createStore as createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';

import wallets from './wallets';
import modals from './modals';
import supplies from './supplies';
import errors from './errors';
import borrows from './borrows';
import agreements from './agreements';
import tokens from './tokens';
import organization from './organization';
import vaults from './vaults';
import userVaults from './userVaults';
import wagmi from './wagmi';

import rootWatcher from '@/saga';

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
    wallets,
    modals,
    supplies,
    errors,
    borrows,
    agreements,
    tokens,
    organization,
    vaults,
    userVaults,
    wagmi,
});

export type Store = ReturnType<typeof store.getState>;

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootWatcher);
